import { Box, Container } from '@mui/material';
import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserProfileWrapper from './components/UserProfileWrapper';

const UserProfilePage = () => {
  const { isSignedIn, isLoaded } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if user is not signed in
    if (isLoaded && !isSignedIn) {
      navigate('/login');
    }
  }, [isSignedIn, isLoaded, navigate]);

  // Show loading or nothing while checking authentication
  if (!isLoaded) {
    return null;
  }

  // Don't render if user is not signed in (will be redirected)
  if (!isSignedIn) {
    return null;
  }

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          py: 4,
        }}
      >
        <UserProfileWrapper />
      </Box>
    </Container>
  );
};

export default UserProfilePage;